<script>
import macarons from "@/common/theme.json";
import cloneDeep from "lodash/cloneDeep";
import sortBy from "lodash/sortBy";
import moment from "moment";

export default {
  props: {
    StatisticsResult: Array,
    StatisticsX: Array,
    StatisticsY: Array,
    legend: Array,
    chartTitle: String,
    chartYTitle: String,
    seriesNameY: String,
    yType: String,
    width: String
  },
  data() {
    const copyResultData = cloneDeep(this.StatisticsResult);
    return {
      copyResultData,
      visionChallengeChart: {},
      type: this.yType,
      chartWidth: this.width || "500px"
    };
  },
  mounted() {
    this.$nextTick(function() {
      this.drawLine();
    });
    window.addEventListener("resize", this.resize);
  },

  destroyed() {
    window.removeEventListener("resize", this.resize);
  },
  methods: {
    drawLine() {
      let weekCounts = 12;
      let intervaltest = undefined;
      this.$echarts.registerTheme("myMacarons", macarons);
      const chartComponent = this.$refs[this.yType];

      let myChart = this.$echarts.init(chartComponent, "myMacarons");
      let getX = this.StatisticsX.map(o => {
        return {
          type: "category",
          data: o
        };
      });
      let getY = this.StatisticsY.map((o, index) => {
        return {
          data: o,
          name: this.legend[index] || this.seriesNameY,
          type: "bar",
          barMaxWidth: 50, //柱图宽度
          barGap: "0" //柱图间距
        };
      });
      const BarSeries = [];
      myChart.setOption({
        title: {
          text: this.chartTitle,
          textStyle: {
            color: "#0A0A0A",
            fontWeight: "normal"
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            lineStyle: {
              width: "0"
            }
          }
        },
        legend: {
          data: this.legend
        },
        grid: {
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: getX,
        yAxis: {
          type: "value",
          name: this.chartYTitle
        },
        series: getY
      });
      this.visionChallengeChart = myChart;
    },
    resize: function() {
      this.visionChallengeChart.resize();
    }
  }
};
</script>
<template>
  <div :ref="yType" :style="{width: chartWidth, height: '350px'}"></div>
</template>


// WEBPACK FOOTER //
// src/components/visionStatistics/basicBarChart.vue